<template>
  <div class="chat-header flex justify-between items-center bg-white">
    <div class="items-center flex-1 hidden xl:flex">
      <div class="p-2 pr-3 hidden xl:block"><img src="@/assets/image/ai/robat_icon.png" class=""></div>
      <div class="hidden xl:block">
        <div class="font-bold">口說練習小幫手</div>
        <div class="text-xs" style="color: #999999;" v-if="selectedAns && selectedAns2">
          {{ selectedAns.name }}>{{ selectedAns2.name }}
        </div>
        <!-- <div class="text-xs" style="color: #999999;">in LiveABC a cute robot</div> -->
      </div>
    </div>
    <!-- - -->
    <!-- <div class="flex-1 flex items-center justify-center">
      <p class="font-black text-xl">{{ selectedStepTitle }}</p>
    </div> -->
    <!-- - -->
    <settings v-if="selectedAns && selectedAns2 && !isDisabledInput" class="settings" :recordArray="recordArray" :selectedAns="selectedAns" :selectedAns2="selectedAns2" />
    <!-- - -->
    <div class="flex justify-end" :class="{ 'flex-1': selectedStep === 0 || isDisabledInput }">
      <!-- <a class="p-2 py-3 xl:p-2 xl:py-4 refresh-btn text-white w-auto cursor-default" @click="restart()" :class="{ 'cursor-pointer': !isDisabledInput || $route.name !== 'viewChat', 'opacity-50': isDisabledInput && $route.name !== 'viewChat', 'opacity-0': $route.name === 'viewChat' }">
        <img src="@/assets/image/ai/coolicon_white.png" class="mr-2 inline-block">重新開始</a> -->
    </div>
  </div>
</template>

<script>
import Bus from '@/components//bus.js'
import settings from '@/components/AiHelper/chat/settings'
import { mapGetters } from 'vuex'
export default {
  name: 'orally_speaking_header',
  props: {
    isBegin: {
      type: Boolean,
      default: true
    },
    selectedStep: {
      type: Number,
      default: 0
    },
    selectedAns: {
      type: Object
    },
    selectedAns2: {
      type: Object
    },
    recordArray: {
      type: Object
    },
    isDisabledInput: {
      type: Boolean,
      default: false
    }
  },
  components: {
    settings
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ]),
    selectedStepTitle () {
        let self = this
        if (!self.isBegin && self.selectedStep === 0) {
          return '情境跟讀練習'
        } else if (!self.isBegin && self.selectedStep === 1) {
          return '情境對話練習'
        }
        return '情境選擇'
      },
    selectedStepTitle_en () {
      let self = this
      if (!self.isBegin && self.selectedStep === 0) {
        return '情境跟讀練習'
      } else if (!self.isBegin && self.selectedStep === 1) {
        return 'AI Chat'
      }
      return 'Topic selection'
    }
  },

  methods: {
    emitPlaybackRates (emitPlaybackRates) {
      this.$emit('emitPlaybackRates', emitPlaybackRates)
    },

    restart () {
      let self = this
      if (!self.isDisabledInput) {
        self.$emit('reStart')

        Bus.$emit('restartData')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .chat-header {
    border-bottom: 1px solid #5A5D9B;
    .refresh-btn {
      background: #5A5D9B;
      transition: .3s;
      &:hover {
        text-decoration: none !important;
        opacity: .8;
      }
    }
  }
</style>
